


















































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import ReasonsCancellationService from '@/domain/justify/service/reasons-cancellation.service';
import ReasonsCancellationDatatable from './reasons-cancellation-datatable.component.vue';
import ReasonsCancellationModal from './reasons-cancellation-modal.component.vue';

@Component({
  components: {
    ReasonsCancellationDatatable,
    ReasonsCancellationModal,
  },
})

export default class ReasonsCancellation extends Vue {
  @Prop({ required: true, default: '' }) private businessUnitId!: string;

  businessUnitReasonCancellationRequired: boolean = false;

  reasonCancellationId: string = '';

  showModal: boolean = false;

  reasonsKey: number = 0;

  reasonsListKey: number = 0;

  profile: string = '';

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    this.profile = UserBusinessUnitService.currentBusinessUnit.profile;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Configuration')) {
        this.businessUnitId = businessUnit.id;
        this.profile = businessUnit.profile;
      }
    })
    this.loadBusinessUnitReasonCancellationRequired();
  }

  @Watch('businessUnitId')
  onBusinessUnitIdChanged() {
    this.reasonsListKey += 1;
    this.loadBusinessUnitReasonCancellationRequired();
  }

  loadBusinessUnitReasonCancellationRequired() {
    ReasonsCancellationService.getBusinessUnitAllowReasonsCancellation(
      this.businessUnitId,
    )
      .then((response: boolean) => {
        this.businessUnitReasonCancellationRequired = response;
      })
      .catch(() => {
        VbSnackbarService.handleHttpError('Erro ao carregar configuração de detalhamento de motivo de cancelamento.');
      });
  }

  handleReasonCancellation() {
    ReasonsCancellationService.businessUnitReasonsCancellationRequired(
      this.businessUnitId,
      this.businessUnitReasonCancellationRequired,
    )
      .then((response) => {
        if (response && response.status !== 200) {
          let message = 'Erro ao salvar configuração. ';
          message += 'Nem todas as justificativas possuem detalhamento.';
          VbSnackbarService.showError(message);
          this.businessUnitReasonCancellationRequired = false;
          return;
        }

        VbSnackbarService.showSuccess('Configuração salva com sucesso!')
      })
      .catch(() => {
        VbSnackbarService.handleHttpError('Erro ao salvar configuração.');
        this.businessUnitReasonCancellationRequired = false;
      });
  }

  openNewReasonCancellationModal() {
    this.reasonsKey += 1;
    this.reasonCancellationId = '';
    this.showModal = true;
  }

  editReasonCancellation(reasonCancellationId: string) {
    this.reasonsKey += 1;
    this.reasonCancellationId = reasonCancellationId;
    this.showModal = true;
  }

  closeModal() {
    this.reasonsListKey += 1;
    this.showModal = false;
    this.reasonCancellationId = '';
    this.loadBusinessUnitReasonCancellationRequired();
  }
}
